import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import ArrowLeft from '#components/svg/icons/ArrowLeft'
import {useAusbildungsplan} from '#hooks/useAusbildungsplan'

function AusbildungsplanKachelIstItem({listItem, handleClick}) {
  const {getTitleForChapter, ready} = useAusbildungsplan(listItem.azubiId)

  if (!ready) {
    return null
  }

  const itemText = item => (
    <div>
      <span>{getTitleForChapter(item.chapterId)}</span>
      <span>{`${item.lastname}, ${item.firstname}`}</span>
    </div>
  )
  return (
    <button
      data-testid="ausbildungsplanKachelListView-item"
      className="uebersicht__kachelListViewItem"
      type="button"
      onClick={() => handleClick(listItem)}
    >
      {itemText(listItem)}
      <ArrowLeft />
    </button>
  )
}

AusbildungsplanKachelIstItem.propTypes = {
  handleClick: PropTypes.func,
  listItem: PropTypes.shape({
    azubiId: PropTypes.number,
    chapterId: PropTypes.string,
    firstname: PropTypes.string,
    id: PropTypes.number,
    lastname: PropTypes.string,
  }),
}

function AusbildungsplanKachelListView({data, handleClick, showAllRedirect, showAllItems, totalCount}) {
  const itemsToShow = showAllItems ? data : data.slice(0, 5)
  const showButton = !showAllItems && totalCount > 5

  function ShowAllButton() {
    return (
      <button
        type="button"
        onClick={() => showAllRedirect()}
        className="kachelListViewShowAllButton"
        data-testid="kachelListViewShowAllButton"
      >
        <span>{i18n.t('showAll')}</span>
        <ArrowLeft />
      </button>
    )
  }

  return (
    <div>
      <div data-testid="uebersicht__kachelListView">
        {itemsToShow.map(item => (
          <AusbildungsplanKachelIstItem
            key={item.chapterId.toString() + item.azubiId.toString()}
            listItem={item}
            handleClick={handleClick}
          />
        ))}
      </div>
      {showButton && <ShowAllButton />}
    </div>
  )
}

AusbildungsplanKachelListView.propTypes = {
  data: PropTypes.array.isRequired,
  handleClick: PropTypes.func.isRequired,
  showAllRedirect: PropTypes.func.isRequired,
  showAllItems: PropTypes.bool.isRequired,
  totalCount: PropTypes.number.isRequired,
}

export default AusbildungsplanKachelListView
